import { render, staticRenderFns } from "./JqxDetailsCheck.vue?vue&type=template&id=2c3fb470&scoped=true"
import script from "./JqxDetailsCheck.vue?vue&type=script&lang=js"
export * from "./JqxDetailsCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3fb470",
  null
  
)

export default component.exports